import { useState, useEffect } from "react"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import "./App.css"
import LoginPage from "./pages/LoginPage"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import Dashboard from "./pages/Dashboard"
import CaptainManagement from "./pages/CaptainManagement"
import UserManagement from "./pages/UserManagement"
import BookingManagement from "./pages/BookingManagement"
import FinancialManagement from "./pages/FinancialManagement"
import NotificationManagement from "./pages/NotificationManagement"
import ReceiptManagement from "./pages/ReceiptManagement"
import OperationalControl from "./pages/OperationalControl"
import BookingExceptions from "./pages/BookingExceptions"
import AuditLog from "./pages/AuditLog"
import CaptainPricing from "./pages/CaptainPricing"
import Layout from "./components/Layout"
import { useLanguage } from "./i18n/LanguageContext"
import { getAuthToken, getAdminInfo, setAuthToken, setAdminInfo, clearAuthData } from "./utils/auth"

function App() {
  const { t } = useLanguage()
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)
  const [adminInfo, setAdminInfoState] = useState(null)

  useEffect(() => {
    // Check if token exists in localStorage
    const token = getAuthToken()
    if (token) {
      setIsAuthenticated(true)
      // Get admin info from localStorage
      const adminData = getAdminInfo()
      if (adminData) {
        setAdminInfoState(adminData)
      }
    }
    setLoading(false)
  }, [])

  const handleLogin = (token, adminData) => {
    setAuthToken(token)
    setAdminInfo(adminData)
    setIsAuthenticated(true)
    setAdminInfoState(adminData)
  }

  const handleLogout = () => {
    clearAuthData()
    setIsAuthenticated(false)
    setAdminInfoState(null)
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
          <p className="mt-4 text-amber-800 font-semibold">{t("common.loading")}</p>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <LoginPage onLogin={handleLogin} />
            )
          }
        />
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <Layout adminInfo={adminInfo} onLogout={handleLogout}>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/captains" element={<CaptainManagement />} />
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/bookings" element={<BookingManagement />} />
                  <Route path="/financials" element={<FinancialManagement />} />
                  <Route path="/notifications" element={<NotificationManagement />} />
                  <Route path="/receipts" element={<ReceiptManagement />} />
                  <Route path="/operations" element={<OperationalControl />} />
                  <Route path="/exceptions" element={<BookingExceptions />} />
                  <Route path="/audit-log" element={<AuditLog />} />
                  <Route path="/captain-pricing" element={<CaptainPricing />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  )
}

export default App
